module.exports = __webpack_public_path__ + "static/media/logo-max3dpro.8881d85b.png";